import * as R from "ramda";
import TreeModel from "tree-model";
//import { message } from "ant-design-vue";

import router from "../../router";
import generalRoutes from "../../router/generalRoute";
import { memberAuthModuleList, userInfo } from "../../views/login/service";

const state = {
  isHasRoute: false,
  memberLoginCheckInfo: {},
  roleRoutes: [],
  roleRoutesRoot: null,
  roleControls: {},
  memberInfo: {},
};

const mutations = {
  SET_ISHASROUTE: (state, isHasRoute) => {
    state.isHasRoute = isHasRoute;
  },
  SET_ROLEROUTES: (state, roleRoutes) => {
    state.roleRoutes = R.clone(roleRoutes);
  },
  SET_MEMBERLOGINCHECKINFO: (state, memberLoginCheckInfo) => {
    state.memberLoginCheckInfo = R.clone(memberLoginCheckInfo);
  },
  SET_ROLEROUTESROOT: (state, roleRoutesRoot) => {
    state.roleRoutesRoot = roleRoutesRoot;
  },
  RESET: (currentState) => {
    for (const [key, value] of Object.entries(state)) {
      currentState[key] = value;
    }
  },
  SET_MEMBERINFO: (state, info) => {
    state.memberInfo = info;
  },
};

const getters = {
  HAS_PERMISSION: (state) => (path) => {
    const roleRoutesRoot = state.roleRoutesRoot;
    let res = roleRoutesRoot.first((node) => {
      return node.model.path === path;
    });

    return Boolean(res);
  },
  GET_FIRSTROUTEPATH: (state) => {
    const roleRoutes = state.roleRoutes;

    let findFirstRoutePath = null;

    for (let i = 0; i < roleRoutes.length; i++) {
      const module = roleRoutes[i];
      if (Array.isArray(module.children) && module.children.length) {
        findFirstRoutePath = module.children[0].path;
        break;
      }
    }

    return findFirstRoutePath;
  },
  GET_MEMBERINFO: (state) => {
    return state.memberInfo;
  },
};

const actions = {
  FETCH_PERMISSION: async ({ commit }) => {
    try {
      const memberRoleModuleListRes = await memberAuthModuleList.request({
        systemId: 13,
      });
      console.log(memberRoleModuleListRes);
      const fullTree = new TreeModel();
      const fullTreeRoot = fullTree.parse(generalRoutes[0]);

      const memberTree = new TreeModel({
        childrenPropertyName: "authModulePojoList",
      });
      const memberTreeRoot = memberTree.parse({
        isRoot: true,
        authModulePojoList: memberRoleModuleListRes.data,
      });

      const traverse = (treeArray) => {
        const tmpTree = [];
        treeArray.map((node) => {
          const nodeModelClone = R.clone(node.model);
          const findNode = memberTreeRoot.first((memberTreeNode) => {
            return memberTreeNode.model.frontendUrl === nodeModelClone.path;
          });

          if (findNode) {
            delete nodeModelClone.children;
            if ((R.is(Array, node.children), node.children.length)) {
              nodeModelClone.children = traverse(node.children);
            }
            tmpTree.push(nodeModelClone);
          } else if (node.model.dev) {
            tmpTree.push(nodeModelClone);
          }
        });

        return tmpTree;
      };

      const roleRoutes = traverse(fullTreeRoot.children);
      console.log("role", roleRoutes);
      const addRoutes = [
        {
          path: "/app",
          name: "App",
          component: () => import("../../layout"),
          children: R.clone(roleRoutes),
        },
      ];

      const roleRoutesTree = new TreeModel();
      const roleRoutesRoot = roleRoutesTree.parse(addRoutes[0]);

      commit("SET_ISHASROUTE", true);
      commit("SET_ROLEROUTES", roleRoutes);
      commit("SET_ROLEROUTESROOT", roleRoutesRoot);
      router.addRoutes(addRoutes);

      // commit("SET_ISHASROUTE", true);
      // commit("SET_ROLEROUTES", roleRoutes);
      // commit("SET_ROLEROUTESROOT", roleRoutesRoot);
      // router.addRoutes(addRoutes);

      // const memberLoginCheckRes = await memberLoginCheck.request();
      // if (memberLoginCheckRes.bizCode === 1) {
      //   if (memberLoginCheckRes.data.status === "LOGOUT") {
      //     window.sessionStorage.clear();
      //     window.location.href = `${window.location.origin}/login`;
      //   }
      //   commit("SET_MEMBERLOGINCHECKINFO", memberLoginCheckRes.data);
      //   if (memberLoginCheckRes.data.user.memberScope === "ADMIN") {
      //     const memberRoleModuleListRes = await memberRoleModuleList.request();
      //     const fullTree = new TreeModel();
      //     const fullTreeRoot = fullTree.parse(generalRoutes[0]);

      //     const memberTree = new TreeModel({
      //       childrenPropertyName: "authModulePojoList",
      //     });
      //     const memberTreeRoot = memberTree.parse({
      //       isRoot: true,
      //       authModulePojoList: memberRoleModuleListRes.data,
      //     });

      //     const traverse = (treeArray) => {
      //       const tmpTree = [];
      //       treeArray.map((node) => {
      //         const nodeModelClone = R.clone(node.model);
      //         const findNode = memberTreeRoot.first((memberTreeNode) => {
      //           return memberTreeNode.model.frontendUrl === nodeModelClone.path;
      //         });

      //         if (findNode) {
      //           delete nodeModelClone.children;
      //           if ((R.is(Array, node.children), node.children.length)) {
      //             nodeModelClone.children = traverse(node.children);
      //           }
      //           tmpTree.push(nodeModelClone);
      //         }
      //       });

      //       return tmpTree;
      //     };

      //     const roleRoutes = traverse(fullTreeRoot.children);
      //     const addRoutes = [
      //       {
      //         path: "/app",
      //         name: "App",
      //         component: () => import("../../layout"),
      //         children: R.clone(roleRoutes),
      //       },
      //     ];

      //     const roleRoutesTree = new TreeModel();
      //     const roleRoutesRoot = roleRoutesTree.parse(addRoutes[0]);

      //     commit("SET_ISHASROUTE", true);
      //     commit("SET_ROLEROUTES", roleRoutes);
      //     commit("SET_ROLEROUTESROOT", roleRoutesRoot);
      //     router.addRoutes(addRoutes);
      //   } else {
      //     const roleRoutesTree = new TreeModel();
      //     const roleRoutesRoot = roleRoutesTree.parse(merchantRoutes);

      //     commit("SET_ISHASROUTE", true);
      //     commit("SET_ROLEROUTES", merchantRoutes[0].children);
      //     commit("SET_ROLEROUTESROOT", roleRoutesRoot);
      //     router.addRoutes(merchantRoutes);
      //   }
      // } else message.warning(memberLoginCheckRes.bizRemind, 4);
    } catch (error) {
      console.error(error);
      // window.sessionStorage.clear();
    }
  },
  FETCH_MEMBERINFO: async ({ commit }) => {
    try {
      const params = {};

      const res = await userInfo.request(params, {
        showBizRemind: true,
      });

      if (res.bizCode === 1) {
        commit("SET_MEMBERINFO", res.data);
      }
    } catch (err) {
      console.error(err);
    }
  },
};

export default {
  namespaced: true,
  state: { ...state },
  getters,
  mutations,
  actions,
};
